import { APP_FEATURES, AppFeaturesConfig } from './../clients/features'
import { environment } from '../config'

export const getAppFeatures = (): AppFeaturesConfig | null => {
  return APP_FEATURES?.[environment?.client] || null
}
